<div class="fullscreen">
  <div class="text-center logo">
    <img width="150px" [src]="logoPath()" alt="Logo" />
  </div>

  <div class="text-center d-flex flex-column justify-content-center main-content">
    <p class="mb-3">{{ message() }}</p>
    <div class="pt-3">
      <dc-dot-loader></dc-dot-loader>
    </div>
  </div>
</div>
